import './FormField.css';

export default function FormField({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  error,
  id,
  showLabel = false,
  required = false,
  disabled = false,
  autoComplete = 'off',
}) {
  const displayText = placeholder ?? label;

  return (
    <div className="form-field">
      {showLabel ? (
        <label className="form-field__label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <div className="form-field__input-wrap">
        <input
          className={`form-field__input${error ? ' form-field__input--invalid' : ''}`}
          aria-label={label}
          type={type}
          value={value}
          id={id}
          name={id}
          autoComplete={autoComplete}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
        {!value ? (
          <span className="form-field__placeholder" aria-hidden="true">
            {displayText}
            {required ? <span className="form-field__required-asterisk">*</span> : null}
          </span>
        ) : null}
        {value ? (
          <button
            type="button"
            className="form-field__clear"
            aria-label="Clear"
            onClick={() => onChange('')}
          >
            ✕
          </button>
        ) : null}
      </div>
      {error ? <p className="form-field__error">{error}</p> : null}
    </div>
  );
}
